import { ACCOMMODATION_TYPE_CODE } from '@spa/shared/constants/accommodationType';
import { PROPERTY_TYPE_CODE } from '@spa/shared/constants/propertyType';
import { RENT_TYPE } from '@spa/shared/constants/rentType';
import { PROPERTY_UNIT_TYPE } from '@spa/shared/constants/unitTypes';

export const getPropertyRentBy = ({ typology, lifecycle, unit_type }) => {
  const accommodationTypeCode = typology.accommodation_type_code;
  const typeCode = typology.type_code;
  const isAccommodationResidence = accommodationTypeCode === ACCOMMODATION_TYPE_CODE.RESIDENCE;
  const isTypeResidence = typeCode === PROPERTY_TYPE_CODE.RESIDENCE;
  const isResidence = isAccommodationResidence && isTypeResidence;

  if (isResidence) {
    const unitType = unit_type;

    if (!unitType || unitType === PROPERTY_UNIT_TYPE.APARTMENT || unitType === PROPERTY_UNIT_TYPE.STUDIO) {
      return RENT_TYPE.ENTIRE_PROPERTY;
    }

    if (unitType === PROPERTY_UNIT_TYPE.BEDROOM) {
      return RENT_TYPE.BEDROOM;
    }

    return RENT_TYPE.BED;
  }

  return lifecycle.rent_by;
};
